import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { InputText } from "primereact/inputtext";
import { Password } from "primereact/password";
import { Button } from "primereact/button";
import { API } from "./App";
import { getAuthHeader } from "./AuthRoute";

function LoginPage() {
  const navigate = useNavigate();

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  const handleLogin = async () => {
    let formErrors = {};

    if (!username) {
      formErrors.username = "Username is required.";
    }

    if (!password) {
      formErrors.password = "Password is required.";
    }

    setErrors(formErrors);

    let noErrors = Object.keys(formErrors).length === 0;
    if (noErrors) {
      setIsLoading(true);
      fetch(API() + "/auth/login", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          username: username,
          password: password,
        }),
      })
        .then((response) => {
          if (response.status === 200) {
            return response.json(); // Parse the response as JSON
          } else {
            return response.text().then((err) => {
              throw new Error(err);
            });
          }
        })
        .then((data) => {
          // Store the access token in local storage or session storage
          localStorage.setItem("access_token", data.access_token);

          // Simulate navigation to the dashboard after successful login
          navigate("/");
        })
        .catch((error) => {
          setErrors({ api: error.message });
        })
        .finally(() => {
          setIsLoading(false);
        });
    }
  };

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      handleLogin();
    }
  };

  return (
    <div
      className="login-page"
      style={{ maxWidth: "400px", margin: "auto", padding: "20px" }}
    >
      <h2>Login</h2>
      <div className="p-fluid">
        <div className="p-field" style={{ paddingBottom: "10px" }}>
          <label htmlFor="username">Username</label>
          <InputText
            id="username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            onKeyPress={handleKeyPress} // Attach key press event
            className={errors.username ? "p-invalid" : ""}
          />
          {errors.username && (
            <small className="p-error">{errors.username}</small>
          )}
        </div>
        <div className="p-field" style={{ paddingBottom: "10px" }}>
          <label htmlFor="password">Password</label>
          <Password
            id="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            onKeyPress={handleKeyPress} // Attach key press event
            toggleMask
            className={errors.password ? "p-invalid" : ""}
            feedback={false}
          />
          {errors.password && (
            <small className="p-error">{errors.password}</small>
          )}
        </div>
        {errors.api && <small className="p-error">{errors.api}</small>}
        <div className="p-field" style={{ paddingBottom: "10px" }}>
          <Button
            label={isLoading ? "Logging in..." : "Login"}
            icon={isLoading ? "pi pi-spin pi-spinner" : "pi pi-sign-in"}
            className="p-button-success"
            onClick={handleLogin}
            disabled={isLoading}
          />
        </div>
        <div style={{ textAlign: "center", marginTop: "10px" }}>
          <p>
            Don't have an account?{" "}
            <a href="https://www.terasol.ch/contact.html">Contact the admin</a>
          </p>
        </div>
      </div>
    </div>
  );
}

export default LoginPage;
